module.exports = __webpack_public_path__ + "files/2e3ff4748851eb017a2da4231eb5cbf1.png";